// parseFloat reads only a dot separator (parseFloat("1,5") → 1), so map comma to
// dot first. The input filter allows at most one separator, so one replace suffices.
export const normalizeDecimal = (raw: string): string => raw.replace(",", ".");
